import { motion } from "motion/react";
import usePreloadImage from "../hooks/use-preload-image";
import PrivacyLink from "./privacy-link";
import Tappable from "./tappable";

export default function Home({ onNext }: { onNext: () => void }) {
  usePreloadImage("/tutorial/1.png");

  return (
    <div className="p-4 h-full grid grid-rows-[max-content_1fr_max-content]">
      <div className="mt-4">
        <p className="text-brand-dark-pink font-bold text-3xl text-center">
          who’s your...
        </p>
        <img
          src="/instagram-valentine-header.png"
          alt="Instagram Valentine"
          className="mt-6 w-full max-w-72 mx-auto"
        />
      </div>

      <div className="-mb-16 self-center">
        <motion.div
          animate={{ rotate: [-5, 5, -5] }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <img src="/envelope.png" alt="" className="w-full max-w-84 mx-auto" />
        </motion.div>
      </div>

      <div>
        <Tappable>
          <button
            className="relative bg-brand-dark-pink text-white p-2 rounded-2xl w-full py-3"
            onClick={onNext}
          >
            <p className="text-[1.4rem] font-bold text-center mr-18">
              Reveal your Valentines
            </p>
            <img
              src="/question-mark-cards-3.png"
              alt=""
              className="w-24 absolute right-0 -top-5"
            />
          </button>
        </Tappable>

        <p className="mt-3 text-center text-xs text-brand-dark-pink font-semibold">
          <span>&copy; 2025 Locket Labs, Inc.</span>
          <span className="inline-block mx-1">&bull;</span>
          <PrivacyLink />
          <span className="inline-block mx-1">&bull;</span>
          <a
            href="https://locket.camera/terms"
            target="_blank"
            className="underline"
          >
            Terms
          </a>
        </p>
      </div>
    </div>
  );
}
